<style  lang="less" rel="stylesheet/less" scoped>
  .loading{
	  background: rgba(0,0,0,0);
	  position:fixed;
	  z-index:30;
	  top:0;
	  width: 100%;
	  height: 100%;
	  pointer-events: none;
	  .content{
		  width: 186px;
		  height: 138px;
		  background: rgba(0,0,0,.5);
		  position: fixed;
		  left: 50%;
		  top:50%;
		  transform: translate(-50%,-50%);
		  border-radius: 8px;
		  z-index: 10;
		  img{
			  position: absolute;
			width: 129px;
			height: 104px;
			left: 50%;
			top: 50%;
			transform: translateY(-50%,-50%);
			transform: translate;
			transform: translate(-50%,-50%);
		  }
        .clock_bor{
			width: 35;
			width: 35px;
			height: 35px;
			border-radius: 50%;
			border: 2px solid#EA9A5F;
			position: absolute;
			right: 24px;
   		    top: 17px;
			.clock{
				width: 25px;
				height: 25px;
				background:#EA9A5F;
				border-radius: 50%;
				position: absolute;
				left: 50%;
				top: 50%;
			   transform: translate(-50%,-50%);
			
			 	.clock_line1{
					position: absolute;
					width: 2px;
					height: 23px;
					left: 12px;
					top: 1px;
					&::after{
					  position: absolute;
					  display: block;
					  content: " ";
					  width: 2px;
					  height: 12px;
					  background: black;
					 border-radius: 2px;
					}
					animation:clock 1s infinite linear;
				}
				.clock_line2{
					position: absolute;
					width: 2px;
					height: 20px;
					left: 12px;
					top: 3px;
					//  background: blue;
					// transform: rotate(90deg);
					animation:clock1 10s infinite linear;
					&::after{
					 position: absolute;
					  display: block;
					  content: " ";
					  width: 2px;
					  height: 11px;
					  background: black;
					 border-radius: 2px;
					}
				}
			}
		 }
	  }
  }
	.loading_bg{
		background: rgba(34,34,34,1);
	}	
	
	
	
</style>
<template>
<div class="loading" :class="{'loading_bg':bg}">
	<div class="content">
		 <img src="/static/img/common/loading.gif" alt="">
		 <div class="clock_bor">
			<div class="clock">
				<div class="clock_line clock_line1"></div>
				<div class="clock_line clock_line2"></div>
			</div>
     	</div>
		 
	</div>
	
</div>
   
</template>
<script>
	export default {
        methods:{},
        props:{
        	bg:{
        		type: [Boolean],
        		default:false,
        	}
        }
        
    }
</script>




// WEBPACK FOOTER //
// src/components/basic/loading.vue